import { useContext } from "react";
import { ConfirmationPageContext } from "./provider";
export const useConfirmationPage = () => {
    const context = useContext(ConfirmationPageContext);
    if (context === null) {
        throw new Error("useConfirmationPage must be used within a ConfirmationPageContext provider");
    }
    return context;
};
